<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :items="exList"
      @loadExercise="loadExercise"
      @loadQuestion="loadQuestion"
      :audienceQuestions="audienceQuestions"
      :contentQuestions="contentQuestions"
    ></results-bar>
    <div v-if="questionMode">
      <results-question
        :key="questionModel.model"
        :all="exList"
        :questionModel="questionModel"
        :audienceQuestions="audienceQuestions"
        :contentQuestions="contentQuestions"
      ></results-question>
    </div>
    <div v-else>
      <results-user
        :key="activeId"
        v-if="activeDoc"
        :doc="activeDoc"
        :audienceQuestions="audienceQuestions"
        :contentQuestions="contentQuestions"
      ></results-user>
    </div>
  </div>
</template>

<script>
import {
  ResultsBar,
  ResultsUser,
  ResultsQuestion,
} from "@/components/results/architecture";
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultArchitecture",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    exList: [],
    activeDoc: null,
    activeId: null,
    questionMode: false,
    questionModel: null,
    audienceQuestions: [
      {
        title: "1) What are the key messages you want audiences to take away?",
        model: "audience.q1",
      },
      { title: "2) What are they trying to achieve?", model: "audience.q2" },
      {
        title: "3) What do you want these audiences to do?",
        model: "audience.q3",
      },
      {
        title: "4) What concerns or questions might they have?",
        model: "audience.q4",
      },
      { title: "5) Anything else?", model: "audience.q5" },
    ],
    contentQuestions: [
      {
        title: "1) How can you demonstrate what you do?",
        model: "content.q1",
      },
      {
        title: "2) How can you demonstrate the impact you will have?",
        model: "content.q2",
      },
      {
        title: "3) How can you show what it is like to engage with you?",
        model: "content.q3",
      },
      {
        title: "4) What would communicate your difference?",
        model: "content.q4",
      },
      { title: "5) Anything else?", model: "content.q5" },
    ],
  }),
  mounted() {
    this.getExercise();
  },
  components: {
    ResultsBar,
    ResultsUser,
    ResultsQuestion,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    loadExercise(id) {
      const doc = this.exList.find((x) => x.id === id);
      console.log("doc", doc, doc.id);
      this.activeId = doc.id;
      this.activeDoc = doc.doc;
      this.questionMode = false;
    },
    loadQuestion(payload) {
      this.questionModel = payload;
      this.questionMode = true;
      console.log("load question", payload);
    },
    getExercise() {
      console.log("load exercise");
      let ref = fb.architectureExCollection.where(
        "pid",
        "==",
        this.currentProjectModel.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.exList = items;
            this.activeId = items[0].id;
            this.activeDoc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
